import axios from 'axios'
import storage from 'store'

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 6000
})

instance.interceptors.request.use((config) => {
  const token = storage.get('token') || ''
  return {
    ...config,
    headers: {
      Accept: 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + token
    }
  }
})

instance.interceptors.response.use(
  (response) => {
    const { data, status } = response
    if (data.code === 1) {
      return data
    } else {
      return Promise.reject(data)
    }
  },
  (error) => {
    const { status } = error.response
    if (status === 401) {
      storage.remove('token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default instance
